const errorStyle = "font-size: 20px";

export function logUnhandledException(err: any) {
	console.error("%cUnhandled Exception", errorStyle);
	console.log(err);
}
